import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PortalCredentialModel } from 'src/portal/pages/credentials/credentials.models';
import { CredentialsService } from 'src/portal/pages/credentials/credentials.service';

@Component({
  selector: 'portal-dashboard-credential',
  templateUrl: './portal-dashboard-credential.component.html',
  styleUrls: ['./portal-dashboard-credential.component.scss'],
  standalone: false
})
export class PortalDashboardCredentialComponent implements OnInit {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private credentialsService: CredentialsService,
    private router: Router
  ) {}
  userName: string;
  renewalStarted = false;

  @Output() loadedComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  renewalAvailableCredentials: PortalCredentialModel[] = [];
  async ngOnInit() {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.userName = userData?.given_name;
    });
    this.renewalAvailableCredentials =
      await this.credentialsService.getRenewalAvailableCredentials();
    this.loadedComplete.emit(true);
  }

  async startRenewal(personCredentialId: string): Promise<void> {
    if (this.renewalStarted) {
      return;
    }
    this.renewalStarted = true;
    const secureLinkId = await this.credentialsService.startRenewal(personCredentialId);
    this.renewalStarted = false;
    if (!secureLinkId) {
      return;
    }
    this.continueRenewal(secureLinkId);
  }

  continueRenewal(secureLinkId: string): void {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      const userId = userData?.sub;
      if (!userId) {
        return;
      }
      this.router.navigateByUrl(`portal/forms/${userId}/application/${secureLinkId}`);
    });
  }
}
